// This file is to keep the shared styles for the individual courses menu components
import {StyleSheet} from "aphrodite";

import {color, spacing} from "@khanacademy/wonder-blocks-tokens";

export const coursesMenuCoreStyles = StyleSheet.create({
    menuItem: {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        cursor: "pointer",
        paddingTop: spacing.xSmall_8,
        paddingBottom: spacing.xSmall_8,
        paddingLeft: spacing.small_12,
        paddingRight: spacing.small_12,
        marginBottom: spacing.xxxSmall_4,
        ":hover": {
            backgroundColor: color.fadedBlue8, // Light blue color
            borderRadius: "5px",
            border: "1px transparent #000",
        },
        ":focus": {
            backgroundColor: color.fadedBlue8, // Light blue color
            borderRadius: "5px",
            border: "1px transparent #000",
        },
        ":active": {
            backgroundColor: color.fadedBlue8, // Light blue color
            borderRadius: "5px",
            border: "1px transparent #000",
        },
        [":hover [data-testid=menu-item-text] " as any]: {
            color: color.activeBlue,
        },
        [":hover [data-testid=caret-icon] " as any]: {
            color: color.blue,
        },
    },
    pinnedLinkText: {
        color: color.blue,
        fontWeight: "bold",
    },
});
